<div class="evaluation-list thin-scrollbar">
  @for (eval of paginatedEvaluations(); track eval.idEvaluation) {
  <mat-card appearance="outlined" class="card-evaluation"
    [ngClass]="{ 'card-leave': leavingEvaluations.has(eval.idEvaluation), 'card-examen': eval.examen }"
    [routerLink]="'edit/'+eval.idEvaluation">
    <div class="card-header" [class.card-header-examen]="eval.examen">
      <div class="card-header-badge" [class.badge-examen]="eval.examen">
        @if(eval.examen){
        <app-icon type="do" icon="groupe-commission" />
        }@else {
        <app-icon type="do" icon="evaluation" />
        }
        <span>N°{{ eval.numEvaluation }}</span>
      </div>
      <span class="card-title">{{ eval.libelle }}</span>
    </div>
    <mat-card-content class="fx-flex-1 card-info">
      <div>
        <app-icon type="do" icon="date-range" />
        @if (eval.dateDebut === eval.dateFin) {
        {{eval.dateDebut | date:'shortDate'}}
        }@else{
        Du {{eval.dateDebut | date:'shortDate'}} au {{eval.dateFin | date:'shortDate'}}
        }
      </div>
      <div>
        <app-icon type="do" icon="departement" />
        {{ eval.departement }}
      </div>
      @if (eval.discipline) {
      <div>
        <app-icon type="do" icon="discipline" />
        {{eval.discipline.libelle}}
      </div>
      }
      @if (eval.cours) {
      <div>
        <app-icon type="do" icon="cours" />
        {{eval.cours.libelle}}
      </div>
      }
    </mat-card-content>
  </mat-card>
  }
</div>
<mat-divider></mat-divider>
<mat-paginator style="border-radius: 4px;" [length]="totalItems()" [pageIndex]="pageIndex()" [pageSize]="pageSize()"
  [pageSizeOptions]="pageSizeOptions()" (page)="onPageChange($event)">
</mat-paginator>